export const formatVietNamPhone = (phone) => {
  if (!phone) return null

  let clean = phone.replace(/[^0-9]/g, '')
  if (clean.startsWith('0')) {
    clean = clean.slice(1)
  }

  // Nếu là 10 số (đầu 03, 05, 07, 08, 09)
  if (/^[35789]\d{9}$/.test(clean)) {
    return `84${clean}`
  }

  // Nếu là 9 số (đầu 3, 5, 7, 8, 9)
  if (/^[35789]\d{8}$/.test(clean)) {
    return `84${clean}`
  }

  // Nếu đã có sẵn 84 và theo sau là 9 hoặc 8 số đầu 35789
  if (/^84[35789]\d{8,9}$/.test(clean)) {
    return clean
  }

  return null
}
